import type { ApplyStepHeaderProps } from '../types/components'

/** Presentational step title block — copy passed in from content layer. */
export function ApplyStepHeader({ title, description }: ApplyStepHeaderProps) {
  return (
    <div className="mb-5 text-center sm:mb-6">
      <h1 className="text-xl font-bold leading-snug text-teal-dark sm:text-2xl md:text-3xl">
        {title}
      </h1>
      {description ? (
        <p className="mx-auto mt-2.5 max-w-md text-sm leading-relaxed text-gray-500 sm:mt-3">
          {description}
        </p>
      ) : null}
    </div>
  )
}
